export const brandTagline =
  "Algorithm-first career placement — less noise for people and hiring teams.";

export const sharedPillars = [
  {
    title: "Algorithm-first matching",
    body: "Roles and people are matched by fit — not by who browsed a board or guessed the right keywords.",
  },
  {
    title: "Verified career signal",
    body: "Profiles, skills, and proof build a clearer picture than a resume dump alone.",
  },
  {
    title: "Less noise, more signal",
    body: "Seekers are not drowning in listings. Employers are not drowning in unqualified resumes.",
  },
];

export const categoryContrasts = [
  {
    oldWay: "Job boards and endless listing searches",
    ourWay: "Relevant opportunities when you are ready — without the board grind",
  },
  {
    oldWay: "Keyword search and resume floods",
    ourWay: "Ranked matches based on role fit, skills, and preferences",
  },
  {
    oldWay: "Employers browsing candidate databases",
    ourWay: "Hiring teams review matches the system surfaces — not open candidate search",
  },
];
